import { Image, ImageProps } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { useMutation } from "react-query";
import { fetchFileContent } from "../mutations/file.mutations";

const FilePreview = ({
	id,
	h,
	mr,
	w,
}: { id: number | string | undefined } & Pick<
	ImageProps,
	"h" | "w" | "mr"
>) => {
	const [blob, setBlob] = useState<Blob | null>(null);
	const { mutate: mutateContent } = useMutation(fetchFileContent, {
		onSuccess: (data) => {
			setBlob(
				new Blob([data], {
					type: "image/png", // should probably be rather managed within fetchFileContent
				}),
			);
		},
	});

	useEffect(() => {
		mutateContent(id);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	if (!blob) {
		return <></>;
	}
	return (
		<>
			<Image
				src={URL.createObjectURL(blob)}
				w={w ?? "40px"}
				h={h ?? "40px"}
				mr={mr}
			></Image>
		</>
	);
};

export default FilePreview;
